
import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const [errors, setErrors] = useState({});

  const contactInfo = {
    address: "4/1, Prem Nagar, Janakpuri, New Delhi, Delhi, 110058",
    hours: "11:00 AM - 7:00 PM",
    email: "harshcares@gmail.com",
    phone: "+91 8188988788"
  };

  const services = [
    {
      title: "Need any help?",
      description: "Contact Customer Support for questions on your products, coaching, or events.",
      category: "Support"
    },
    {
      title: "Media or speaking Inquiry",
      description: "Robbins Research International, Inc. has a dedicated media department. Members of the press are welcome to contact us.",
      category: "Media"
    },
    {
      title: "Trading Consultation",
      description: "Get personalized guidance on your trading journey from our expert team.",
      category: "Consultation"
    },
    {
      title: "Business Partnership",
      description: "Explore collaboration opportunities and business partnerships with Harsh Bhagat.",
      category: "Partnership"
    }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = 'First name is required';
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Last name is required';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }

    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = 'Phone number is required';
    } else if (!/^[0-9]{10}$/.test(formData.phoneNumber.replace(/[^0-9]/g, ''))) {
      newErrors.phoneNumber = 'Please enter a valid 10-digit phone number';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters long';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('');

    // Simulate form submission
    try {
      await new Promise(resolve => setTimeout(resolve, 2000));

      setSubmitStatus('success');
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        message: ''
      });
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const formatPhoneNumber = (value) => {
    const phoneNumber = value.replace(/[^0-9]/g, '');
    if (phoneNumber.length <= 10) {
      return phoneNumber.replace(/(\d{5})(\d{5})/, '$1 $2');
    }
    return phoneNumber.slice(0, 10).replace(/(\d{5})(\d{5})/, '$1 $2');
  };

  return (
    <div className="contact-page">
      {/* Background with gradient */}
      <div className="contact-background">
        {/* Decorative circles */}
        <div className="decorative-circles">
          <div className="circle circle-1"></div>
          <div className="circle circle-2"></div>
          <div className="circle circle-3"></div>
        </div>

        {/* Main heading */}
        <div className="main-heading">
          <h2 className="contact-title">CONTACT US</h2>
        </div>

        <div className="contact-content">
          {/* Left section - Contact Info */}
          <div className="contact-info">
            <div className="discover-section">
              <h3 className="discover-title">DISCOVER US</h3>
              <p className="discover-description">
                Harsh Bhagat is here to help you! Our experts are available to answer any questions you might have. We've got the answers.
              </p>
            </div>

            <div className="contact-details">
              <div className="contact-item">
                <h4 className="contact-label">WORKING HOURS</h4>
                <p className="contact-value">{contactInfo.hours}</p>
              </div>

              <div className="contact-item">
                <h4 className="contact-label">ADDRESS</h4>
                <p className="contact-value">{contactInfo.address}</p>
              </div>

              <div className="contact-item">
                <h4 className="contact-label">EMAIL US</h4>
                <p className="contact-value">{contactInfo.email}</p>
              </div>

              <div className="contact-item">
                <h4 className="contact-label">CALL US</h4>
                <p className="contact-value">{contactInfo.phone}</p>
              </div>
            </div>
          </div>

          {/* Right section - Contact Form */}
          <div className="form-wrapper">
            <div className="form-container">
              <div className="form-header">
                <h2 className="form-title">Have A Qurey?</h2>
                <p className="form-subtitle">
                  Let's align our goals! Reach out and let the magic of collaboration illuminate our goals.
                </p>
              </div>

              {submitStatus === 'success' && (
                <div className="success-message">
                  <div className="success-icon">✅</div>
                  <h3>Message Sent Successfully!</h3>
                  <p>Thank you for reaching out. We'll get back to you within 24 hours.</p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="error-message">
                  <div className="error-icon">❌</div>
                  <h3>Something went wrong</h3>
                  <p>Please try again or contact us directly at {contactInfo.email}</p>
                </div>
              )}

              {submitStatus !== 'success' && (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row" >
                    <div className="form-group">
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        className={`form-input ${errors.firstName ? 'error' : ''}`}
                        value={formData.firstName}
                        onChange={handleInputChange}
                        placeholder="First Name"
                      />
                      {errors.firstName && <span className="field-error">{errors.firstName}</span>}
                    </div>

                    <div className="form-group">
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        className={`form-input ${errors.lastName ? 'error' : ''}`}
                        value={formData.lastName}
                        onChange={handleInputChange}
                        placeholder="Last Name"
                      />
                      {errors.lastName && <span className="field-error">{errors.lastName}</span>}
                    </div>
                  </div>

                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className={`form-input ${errors.email ? 'error' : ''}`}
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Email"
                    />
                    {errors.email && <span className="field-error">{errors.email}</span>}
                  </div>

                  <div className="form-group">
                    <input
                      type="tel"
                      id="phoneNumber"
                      name="phoneNumber"
                      className={`form-input ${errors.phoneNumber ? 'error' : ''}`}
                      value={formatPhoneNumber(formData.phoneNumber)}
                      onChange={(e) => handleInputChange({
                        target: {
                          name: 'phoneNumber',
                          value: e.target.value.replace(/[^0-9]/g, '').slice(0, 10)
                        }
                      })}
                      placeholder="Phone Number"
                    />
                    {errors.phoneNumber && <span className="field-error">{errors.phoneNumber}</span>}
                  </div>

                  <div className="form-group">
                    <textarea
                      id="message"
                      name="message"
                      className={`form-input message-input ${errors.message ? 'error' : ''}`}
                      value={formData.message}
                      onChange={handleInputChange}
                      placeholder="Message"
                      rows="4"
                    />
                    {errors.message && <span className="field-error">{errors.message}</span>}
                  </div>

                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="loading-spinner"></span>
                        Sending...
                      </>
                    ) : (
                      'Send'
                    )}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;